export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-12">
              <span className="block">Nationwide Pallet Solution</span>
              <span className="block">Your Trusted Partner</span>
              <span className="block">Since 2021</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <div className="text-5xl font-bold text-orange-600 mb-2">5+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-orange-600 mb-2">250K+</div>
                <div className="text-gray-600">Pallets Delivered</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-orange-600 mb-2">150+</div>
                <div className="text-gray-600">Happy Clients</div>
              </div>
            </div>

            <div className="mt-12 space-y-4">
              <p className="text-gray-700 leading-relaxed">
                Since 2021, Nationwide Pallet Solution has been the premier destination to <strong>Buy 48x40 Pallets Nationwide</strong>, <strong>Buy Custom Pallets Nationwide</strong>, <strong>Buy Standard Pallets Nationwide</strong>, and <strong>Buy GMA Pallets Nationwide</strong>.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Our commitment to quality, reliability, and customer service has made us the trusted choice for businesses across all 50 states. Whether you need standard dimensions or custom specifications, we deliver excellence every time.
              </p>
            </div>
          </div>

          <div className="relative h-[600px] rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://static.readdy.ai/image/0eec0f6b43802b90423f55e0902fba48/efbcd825dfda915c5600f2dc3c1bdf6c.png"
              alt="Nationwide Pallet Delivery Service"
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
}